"use strict";

var _createForOfIteratorHelper = require("/Users/michael/Documents/michaelw54.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/michael/Documents/michaelw54.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/michael/Documents/michaelw54.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Attractor = void 0;

var Enums_1 = require("../../../../Enums");

var Utils_1 = require("../../../../Utils");

var Attractor = /*#__PURE__*/function () {
  function Attractor(container) {
    _classCallCheck(this, Attractor);

    this.container = container;
  }

  _createClass(Attractor, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container;
      var options = container.options;
      var mouse = container.interactivity.mouse;
      var events = options.interactivity.events;

      if (!(events.onHover.enable && mouse.position || events.onClick.enable && mouse.clickPosition)) {
        return false;
      }

      var hoverMode = events.onHover.mode;
      var clickMode = events.onClick.mode;
      return Utils_1.Utils.isInArray(Enums_1.HoverMode.attract, hoverMode) || Utils_1.Utils.isInArray(Enums_1.ClickMode.attract, clickMode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact() {
      var container = this.container;
      var options = container.options;
      var mouseMoveStatus = container.interactivity.status === Utils_1.Constants.mouseMoveEvent;
      var events = options.interactivity.events;
      var hoverEnabled = events.onHover.enable;
      var hoverMode = events.onHover.mode;
      var clickEnabled = events.onClick.enable;
      var clickMode = events.onClick.mode;

      if (mouseMoveStatus && hoverEnabled && Utils_1.Utils.isInArray(Enums_1.HoverMode.attract, hoverMode)) {
        this.hoverAttract();
      } else if (clickEnabled && Utils_1.Utils.isInArray(Enums_1.ClickMode.attract, clickMode)) {
        this.clickAttract();
      }
    }
  }, {
    key: "hoverAttract",
    value: function hoverAttract() {
      var container = this.container;
      var mousePos = container.interactivity.mouse.position;

      if (!mousePos) {
        return;
      }

      var attractRadius = container.retina.attractModeDistance;
      this.processAttract(mousePos, attractRadius, new Utils_1.Circle(mousePos.x, mousePos.y, attractRadius));
    }
  }, {
    key: "processAttract",
    value: function processAttract(position, attractRadius, area) {
      var container = this.container;
      var query = container.particles.quadTree.query(area);

      var _iterator = _createForOfIteratorHelper(query),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var particle = _step.value;

          var _Utils_1$Utils$getDis = Utils_1.Utils.getDistances(particle.position, position),
              dx = _Utils_1$Utils$getDis.dx,
              dy = _Utils_1$Utils$getDis.dy,
              distance = _Utils_1$Utils$getDis.distance;

          var normVec = {
            x: dx / distance,
            y: dy / distance
          };
          var velocity = container.options.interactivity.modes.attract.speed;
          var attractFactor = Utils_1.Utils.clamp((1 - Math.pow(distance / attractRadius, 2)) * velocity, 0, 50);
          particle.position.x = particle.position.x - normVec.x * attractFactor;
          particle.position.y = particle.position.y - normVec.y * attractFactor;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "clickAttract",
    value: function clickAttract() {
      var container = this.container;

      if (!container.attract.finish) {
        if (!container.attract.count) {
          container.attract.count = 0;
        }

        container.attract.count++;

        if (container.attract.count === container.particles.count) {
          container.attract.finish = true;
        }
      }

      if (container.attract.clicking) {
        var mousePos = container.interactivity.mouse.clickPosition;

        if (!mousePos) {
          return;
        }

        var attractRadius = container.retina.attractModeDistance;
        this.processAttract(mousePos, attractRadius, new Utils_1.Circle(mousePos.x, mousePos.y, attractRadius));
      } else if (container.attract.clicking === false) {
        container.attract.particles = [];
      }

      return;
    }
  }]);

  return Attractor;
}();

exports.Attractor = Attractor;